<template >  
  <div >
    <div class="img">
      <img src="img/hospitalave.png"> 
    </div>
    <div class="containerLogin">
  <div class="login-content">
    <div v-if="loading" class="loading-container" style="margin: 50%;">
      <rotate-square class="center" size="45px" />
            </div>
    <form class="formLogin center" v-else @submit="onFormValidate">
      <img src="img/lavatotem.png">
      <br><br><br><br><br>
      
      <div
            v-if="mensagem"
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
          >
            <strong>{{ mensagem }}</strong>
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
              @click="Fechar()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

             <div class="input-div one">
                <div class="i">
                    <i class="fas fa-user"></i>
                </div>
                <div class="div">
                <h5>Usuario</h5>
                <input
                    v-model="email"
                    type="text"
                    class="input"
                    required
                    
                  />
                </div>
             </div>
             <div class="input-div pass">
                <div class="i"> 
                   <i class="fas fa-lock"></i>
                </div>
                <div class="div">
                <h5>Senha</h5>
                   <input
                    v-model="senha"
                    type="password"
                    class="input"
                    required
                  />
               </div>
            </div>
                
                <button class="btnLogin " @click="Login()" >
                      Login
                    </button>
            <!-- <button
                  class="a btn-link"
                  @click="$router.push('/esqueci-senha')"
                >
                Esqueceu a senha? Clique aqui!
                </button>

              <div >
                <a class="a"
                  href="https://prismafive.com.br/politica-de-privacidade/"
                  target="_blank"
                >
                Ao realizar o login, declaro que li e estou de acordo com as políticas de privacidade.
                </a>
              </div> -->
            </form>
      </div>
      <div class="botao-sair" v-if="this.ipcRenderer !=null">
        <b-button variant="danger" @click="fecharApp()">
                    <span>Fechar</span>
                </b-button>
      </div>
      <div class="grupo" >
        <h2>Grupo</h2>
        <h2>Lava Sul</h2>
      </div>
      <b-modal 
            :title="`Atualização do sistema`"
            size="sm"
            v-model="openModalAtualizacao" 
            hide-footer
            :no-close-on-backdrop=true
            hide-header-close
            centered
        >
            <div class="d-flex flex-column align-items-center">   
                <p id="message"></p>                           
                <b-button variant="success" class="custom-button hidden" id="restart-button" @click="restartApp()">
                    <span>Reiniciar</span>
                </b-button>
            </div>
        </b-modal>

  </div>
  </div>

</template>


<script>
/* eslint-disable */
import { RotateSquare } from "vue-loading-spinner";
import "../../assets/scss/style.css"
import { isElectron } from '../../shared/isElectron';

export default {
name: "Login",
components: { RotateSquare },
data() {
  return {
    loading: false,
    email: "",
    senha: "",
    mensagem: "",
    openModalAtualizacao:false,
    ipcRenderer: null,
  };
},
computed: {
  ViewModel() {
    return {
      Login: this.email,
      Senha: this.senha
    };
  }
},
async mounted() {

  const inputs = document.querySelectorAll(".input");

  function addcl(){
    let parent = this.parentNode.parentNode;
    parent.classList.add("focus");
  }

  function remcl(){
    let parent = this.parentNode.parentNode;
    if(this.value == ""){
      parent.classList.remove("focus");
    }
  }

  inputs.forEach(input => {
    if(input.value) input.parentNode.parentNode.classList.add("focus");
    input.addEventListener("focus", addcl);
    input.addEventListener("blur", remcl);
  });

  if (this.$route.params.id && !this.$route.params.sync) {
    this.$store.dispatch("logout");
    this.LoginPortal();
  }

  if (isElectron) {
      const { ipcRenderer } = await import('electron');
      this.ipcRenderer = ipcRenderer;
      ipcRenderer.on('update_available', async () => {
        await this.openModal();
        const message = document.getElementById('message');
        ipcRenderer.removeAllListeners('update_available');
        message.innerText = 'Uma nova atualização está disponível. Fazendo o download agora...';
      });
      ipcRenderer.on('update_downloaded', async () => {
        await this.openModal();
        const message = document.getElementById('message');
        const restartButton = document.getElementById('restart-button');
        ipcRenderer.removeAllListeners('update_downloaded');
        message.innerText = 'Atualização baixada. Ela será instalada ao reiniciar';
        restartButton.classList.remove('hidden');
      });
    }
  
},
updated(){
  const inputs = document.querySelectorAll(".input");



  function addcl(){
    let parent = this.parentNode.parentNode;
    parent.classList.add("focus");
  }

  function remcl(){
    let parent = this.parentNode.parentNode;
    if(this.value == ""){
      parent.classList.remove("focus");
    }
  }

  

  inputs.forEach(input => {
    if(input.value) input.parentNode.parentNode.classList.add("focus");
    input.addEventListener("focus", addcl);
    input.addEventListener("blur", remcl);
  });
},
methods: {
  openModal(){
    this.openModalAtualizacao = true;
  },
  restartApp() {
    this.ipcRenderer.send('restart_app');
  },
  fecharApp(){
    this.ipcRenderer.send('fechar-aplicativo');
  },
  onFormValidate() {
    if (this.email.trim() || this.senha) {
      return;
    }
    this.preventDefault();
  },
  Fechar() {
    this.mensagem = "";
  },
  Login() {
    this.loading = true;
    this.$http({
      url: "login",
      data: this.ViewModel,
      method: "POST"
    })
      .then((resp) => {
          this.loading = false;
          const token = resp.data;
          // Add the following line:
          this.$http.defaults.headers.common["Authorization"] =
          "bearer " + token.tokenDeAcesso;
          
          this.$store.dispatch("login", token).then(() => this.$router.push("/"));
        

      })
      .catch((erro) => {
        this.loading = false;
        this.mensagem = erro.response.data.mensagem
        this.$notify({
          data: erro.response.data.erros,
          type: "warn",
          duration: 10000
        });
        localStorage.removeItem("user-token");
      });
  }
}
};
</script>
<style scoped>
#ddown2 {
margin-top: 1rem;
}
#notification {
  position: fixed;
  bottom: 20px;
  left: 20px;
  width: 200px;
  padding: 20px;
  border-radius: 5px;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.hidden {
  display: none;
}
.botao-sair{
  position: absolute;
  bottom: 20px;
  right: 20px; 
}
.grupo{
  position: absolute;
  bottom: 0;
  left: 20px;
  color: #2c6695;
}
.loading-container{
  position: absolute;
}

</style> 
